import React from "react";
import ShowMoreArrow from "../../files/components/showMoreArrow.js";
import ShowLessArrow from "../../files/components/showLessArrow.js";

function formTable(JSONtable) {
  let tableRows = []; //Все строки таблицы

  let groupFlag = false; //Флаг начала/конца группы
  let groupNameCellContent = []; // значения в 1 стоблце (name)
  let groupValueCellContent = []; // значения во 2 стоблце (value)

  // Добавление заголовка к таблице
  tableRows.push(
    <tr>
      <td dangerouslySetInnerHTML={{ __html: JSONtable.columns[0] }} className="tableHeaderCell"
        style={{ borderRadius: "5px 0px 0px 0px", width: "70%" }} />
      <td dangerouslySetInnerHTML={{ __html: JSONtable.columns[1] }} className="tableHeaderCell"
        style={{ borderRadius: "0px 5px 0px 0px", textAlign:"center" }} />
    </tr>
  );

  // Добавление строк к таблице
  JSONtable.rows.forEach((value) => {
    //Если группа - добавить название группы в массив с названиями и <br/> в массив со значениями
    if (value.isGroup) {
      groupFlag = true;
      groupNameCellContent.push(
        <div dangerouslySetInnerHTML={{ __html: value.items[0] }} />
      );
      groupValueCellContent.push(
        <div>
          <br />
        </div>
      );
      }else if (!value.isGroup && value.isGroupItem && groupFlag) {
        const groupCellRow = (
          <tr>
            <td>{groupNameCellContent}</td>
            <td style={{ textAlign: "center" }}>{groupValueCellContent}</td>
          </tr>
        );
  
        tableRows.push(groupCellRow);
  
        groupFlag = false;
  
      //Если элемент группы - добавить название элемента в массив с названиями и значение элемента в массив со значениями
    } else if (value.isGroupItem) {
      groupNameCellContent.push(
        <div
          className="isgroupitemName"
          dangerouslySetInnerHTML={{ __html: value.items[0] }}
        />
      );
      groupValueCellContent.push(
        <div
          className="isgroupitem"
          dangerouslySetInnerHTML={{ __html: value.items[1] }}
        />
      );
    }

    //Если простая строка - добавить строку к таблице
    else {
      const row = (
        <tr>
          <td dangerouslySetInnerHTML={{ __html: value.items[0] }} />
          <td dangerouslySetInnerHTML={{ __html: value.items[1] }}
            style={{ textAlign: "center" }} />
        </tr>
      );
      tableRows.push(row);
    }
  });

  return tableRows;
}

function formList0(JSONlist) {
  let items = [];
    JSONlist.items.map((value, index) => {
        const text = value.text ? value.text : value;
    items.push(<li dangerouslySetInnerHTML={{ __html: text }} />);
  });

  return <ul>{items}</ul>;
}


function formList(JSONlist) {
    let items = [];
    JSONlist.items.map((value, index) => {
        const text = value.text ? value.text : value;
        let sublist = '';
        if (value.sublist) {
            sublist = formList(value.sublist);
        }
        items.push(<li>{text}{sublist}</li>);
    });

    return <ul>{items}</ul>;
}

export function formDevice(JSONdevice, handlerShrink, handlerZoom) {
  const name = JSONdevice.name;

  const deviceIdDiv = "div" + JSONdevice.id;
  const deviceIdPreviewDiv = "div" + JSONdevice.id + " preview";
  const deviceIdButton = "button" + JSONdevice.id;

  const image = (
    <img
      alt={JSONdevice.imgAlt}
      src={window.location.origin + JSONdevice.img}
          style={{ width: "10.95em", cursor: "zoom-in" }}
          onClick={() => handlerZoom(JSONdevice.img)}
    />
  );

  let contents = [];
  let isCollapsable = false;

  JSONdevice.description.map((value, index) => {
    if (!value.isPreview) {
      isCollapsable = true;
    }
    const content = [];
    content.push(<br/>);

    if (value.header) {
      content.push(<div dangerouslySetInnerHTML={{ __html: value.header }} />);
    }
    if (value.text) {
      content.push(<div dangerouslySetInnerHTML={{ __html: value.text }} />);
    }
    if (value.list) {
      content.push(<div className="listContainer">{formList(value.list)}</div>);
    }
    if (value.table) {
      content.push(<br />);
      content.push(
        <div className="theTableContainer">
              <table cellSpacing="0" className="thetable">
                  <tbody>
                      {formTable(value.table)}
                  </tbody>
          </table>
        </div>
      );
    }

    contents.push(
      <div artid={deviceIdDiv} role={value.isPreview ? "preview" : "othertext"} className={value.isPreview ? "heatmeters_display" : "heatmeters_display heatmeters_hide"}>
        {content}
      </div>
    );
  });

  const theContent = (
    <div>
      <div className="caption" dangerouslySetInnerHTML={{ __html: name }} />
      <div style={{ display: "table-row" }}>
        <div
          className="imageCell"
          style={{
            display: "table-cell",
            verticalAlign: "top",
            minWidth: "12.3em"
          }}
        >
          <div style={{ marginTop: "0.3em" }}>{image}</div>
        </div>
        <div style={{ display: "table-cell", position: "relative", width: "100%" }}>
          <div className={isCollapsable ? deviceIdPreviewDiv : null}>
            {contents}
          </div>
        </div>
      </div>
    </div>
  );

  const theButton = (
    <div style={{ display: isCollapsable ? "initial" : "none" }}>
      <div heatmeterid={deviceIdButton} className="theButton" active="true">
        <div className="arrowContainer" onClick={() => handlerShrink(JSONdevice.id)}>
          <ShowMoreArrow />
        </div>
      </div>
      <div heatmeterid={deviceIdButton} className="theButton hiddenButton" active="false">
        <div className="arrowContainer" onClick={() => handlerShrink(JSONdevice.id)}>
          <ShowLessArrow />
        </div>
      </div>
    </div>
  );

  const container = (
    <div className="content">
      {theContent}
      {theButton}
    </div>
  );
  return container;
}
